module.exports = __webpack_public_path__ + "static/media/Icon - View holidays for entities.d2a46c2b.svg";